export const FALLBACK_APP_NAME = "Payceey HRMS";
export const ICON_SIZES = [192, 512];

/** Box for drawing a w×h logo centered on a size×size square with padding, never stretched. */
export function fitIcon(w, h, size, pad = 0.1) {
  const box = size * (1 - 2 * pad);
  const scale = w > 0 && h > 0 ? Math.min(box / w, box / h) : 0;
  const width = scale ? w * scale : box;
  const height = scale ? h * scale : box;
  return { x: (size - width) / 2, y: (size - height) / 2, width, height };
}

export function buildManifest({ name, origin, themeColor, icons }) {
  const appName = (name || "").trim() || FALLBACK_APP_NAME;
  return {
    id: `${origin}/`,
    name: appName,
    short_name: appName,
    start_url: `${origin}/`,
    scope: `${origin}/`,
    display: "standalone",
    background_color: "#ffffff",
    theme_color: themeColor,
    icons: icons.map(({ src, size }) => ({
      src,
      sizes: `${size}x${size}`,
      type: "image/png",
      purpose: "any",
    })),
  };
}
